








import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  ExpenseCategory,
  HsabExpenseCategory
} from "../types";
import { expenseCategoryIcon } from "@/shared/awesomeIconMapper";

@Component({})
export default class CategoryPill extends Vue {
  expenseCategoryIcon = expenseCategoryIcon;
  @Prop()
  selected: boolean;

  @Prop({ required: true })
  icon: string;

  @Prop({ required: true })
  category: ExpenseCategory | HsabExpenseCategory;

  @Prop()
  readOnly: boolean;

}
